// src/ecom-v1-shippo-configuration-shippo-configurations.public.ts
import { renameKeysFromRESTResponseToSDKResponse as renameKeysFromRESTResponseToSDKResponse2 } from "@wix/sdk-runtime/rename-all-nested-keys";
import { transformRESTAddressToSDKAddress as transformRESTAddressToSDKAddress2 } from "@wix/sdk-runtime/transformations/address";
import { transformRESTTimestampToSDKTimestamp as transformRESTTimestampToSDKTimestamp2 } from "@wix/sdk-runtime/transformations/timestamp";
import { transformPaths as transformPaths3 } from "@wix/sdk-runtime/transformations/transform-paths";
import { EventDefinition } from "@wix/sdk-types";

// src/ecom-v1-shippo-configuration-shippo-configurations.universal.ts
import { transformError as sdkTransformError } from "@wix/sdk-runtime/transform-error";
import { queryBuilder } from "@wix/sdk-runtime/query-builder";
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse
} from "@wix/sdk-runtime/rename-all-nested-keys";

// src/ecom-v1-shippo-configuration-shippo-configurations.http.ts
import { toURLSearchParams } from "@wix/sdk-runtime/rest-modules";
import { transformSDKFloatToRESTFloat } from "@wix/sdk-runtime/transformations/float";
import { transformRESTFloatToSDKFloat } from "@wix/sdk-runtime/transformations/float";
import { transformSDKTimestampToRESTTimestamp } from "@wix/sdk-runtime/transformations/timestamp";
import { transformRESTTimestampToSDKTimestamp } from "@wix/sdk-runtime/transformations/timestamp";
import { transformSDKFieldMaskToRESTFieldMask } from "@wix/sdk-runtime/transformations/field-mask";
import { transformPaths } from "@wix/sdk-runtime/transformations/transform-paths";
import { resolveUrl } from "@wix/sdk-runtime/rest-modules";
function resolveWixEcomDeliveryV1ShippoServiceUrl(opts) {
  const domainToMappings = {
    "manage._base_domain_": [
      {
        srcPath: "/_api/shippo-service",
        destPath: ""
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/ecom/v1/shippo-configurations",
        destPath: "/v1/shippo-configurations"
      }
    ]
  };
  return resolveUrl(Object.assign(opts, { domainToMappings }));
}
var PACKAGE_NAME = "@wix/auto_sdk_ecom_shippo-configurations";
function createShippoConfiguration(payload) {
  function __createShippoConfiguration({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "shippoConfiguration.createdDate" },
          { path: "shippoConfiguration.updatedDate" }
        ]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
          { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "POST",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.CreateShippoConfiguration",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "shippoConfiguration.createdDate" },
            { path: "shippoConfiguration.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
            { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __createShippoConfiguration;
}
function getShippoConfiguration(payload) {
  function __getShippoConfiguration({ host }) {
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "GET",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.GetShippoConfiguration",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations/{shippoConfigurationId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "shippoConfiguration.createdDate" },
            { path: "shippoConfiguration.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
            { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __getShippoConfiguration;
}
function updateShippoConfiguration(payload) {
  function __updateShippoConfiguration({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: "fieldMask" }]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "shippoConfiguration.createdDate" },
          { path: "shippoConfiguration.updatedDate" }
        ]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
          { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "PATCH",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.UpdateShippoConfiguration",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations/{shippoConfiguration.id}",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "shippoConfiguration.createdDate" },
            { path: "shippoConfiguration.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
            { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __updateShippoConfiguration;
}
function deleteShippoConfiguration(payload) {
  function __deleteShippoConfiguration({ host }) {
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "DELETE",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.DeleteShippoConfiguration",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations/{shippoConfigurationId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload)
    };
    return metadata;
  }
  return __deleteShippoConfiguration;
}
function queryShippoConfigurations(payload) {
  function __queryShippoConfigurations({ host }) {
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "POST",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.QueryShippoConfigurations",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations/query",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "shippoConfigurations.createdDate" },
            { path: "shippoConfigurations.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "shippoConfigurations.shipFromAddress.geocode.latitude" },
            {
              path: "shippoConfigurations.shipFromAddress.geocode.longitude"
            }
          ]
        }
      ]),
      fallback: [
        {
          method: "POST",
          url: resolveWixEcomDeliveryV1ShippoServiceUrl({
            protoPath: "/v1/shippo-configurations/query",
            data: payload,
            host
          }),
          data: payload
        }
      ]
    };
    return metadata;
  }
  return __queryShippoConfigurations;
}
function updateExtendedFields(payload) {
  function __updateExtendedFields({ host }) {
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "POST",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.UpdateExtendedFields",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations/{id}/update-extended-fields",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "shippoConfiguration.createdDate" },
            { path: "shippoConfiguration.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
            { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __updateExtendedFields;
}
function addDeliveryRegion(payload) {
  function __addDeliveryRegion({ host }) {
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "POST",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.AddDeliveryRegion",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations/{shippoConfigurationId}/delivery-regions",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "shippoConfiguration.createdDate" },
            { path: "shippoConfiguration.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
            { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __addDeliveryRegion;
}
function removeDeliveryRegion(payload) {
  function __removeDeliveryRegion({ host }) {
    const metadata = {
      entityFqdn: "wix.ecom.v1.shippo_configuration",
      method: "DELETE",
      methodFqn: "wix.ecom.delivery.v1.ShippoService.RemoveDeliveryRegion",
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryV1ShippoServiceUrl({
        protoPath: "/v1/shippo-configurations/{shippoConfigurationId}/delivery-regions/{deliveryRegionId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "shippoConfiguration.createdDate" },
            { path: "shippoConfiguration.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "shippoConfiguration.shipFromAddress.geocode.latitude" },
            { path: "shippoConfiguration.shipFromAddress.geocode.longitude" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __removeDeliveryRegion;
}

// src/ecom-v1-shippo-configuration-shippo-configurations.universal.ts
import { transformSDKAddressToRESTAddress } from "@wix/sdk-runtime/transformations/address";
import { transformRESTAddressToSDKAddress } from "@wix/sdk-runtime/transformations/address";
import { transformPaths as transformPaths2 } from "@wix/sdk-runtime/transformations/transform-paths";
var DomesticService = /* @__PURE__ */ ((DomesticService2) => {
  DomesticService2["UNKNOWN_DOMESTIC_SERVICE"] = "UNKNOWN_DOMESTIC_SERVICE";
  DomesticService2["GROUND_ADVANTAGE"] = "GROUND_ADVANTAGE";
  DomesticService2["PRIORITY_MAIL"] = "PRIORITY_MAIL";
  DomesticService2["PRIORITY_MAIL_EXPRESS"] = "PRIORITY_MAIL_EXPRESS";
  return DomesticService2;
})(DomesticService || {});
var CalculationType = /* @__PURE__ */ ((CalculationType2) => {
  CalculationType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  CalculationType2["FIXED"] = "FIXED";
  CalculationType2["PERCENTAGE"] = "PERCENTAGE";
  return CalculationType2;
})(CalculationType || {});
var InternationalService = /* @__PURE__ */ ((InternationalService2) => {
  InternationalService2["UNKNOWN_INTERNATIONAL_SERVICE"] = "UNKNOWN_INTERNATIONAL_SERVICE";
  InternationalService2["FIRST_CLASS_PACKAGE_INTERNATIONAL"] = "FIRST_CLASS_PACKAGE_INTERNATIONAL";
  InternationalService2["PRIORITY_MAIL_INTERNATIONAL"] = "PRIORITY_MAIL_INTERNATIONAL";
  InternationalService2["PRIORITY_MAIL_EXPRESS_INTERNATIONAL"] = "PRIORITY_MAIL_EXPRESS_INTERNATIONAL";
  return InternationalService2;
})(InternationalService || {});
var PackageType = /* @__PURE__ */ ((PackageType2) => {
  PackageType2["UNKNOWN_PACKAGE_TYPE"] = "UNKNOWN_PACKAGE_TYPE";
  PackageType2["CUSTOM"] = "CUSTOM";
  PackageType2["FLAT_RATE_ENVELOPE"] = "FLAT_RATE_ENVELOPE";
  PackageType2["PADDED_FLAT_RATE_ENVELOPE"] = "PADDED_FLAT_RATE_ENVELOPE";
  PackageType2["SMALL_FLAT_RATE_BOX"] = "SMALL_FLAT_RATE_BOX";
  PackageType2["MEDIUM_FLAT_RATE_BOX_1"] = "MEDIUM_FLAT_RATE_BOX_1";
  PackageType2["MEDIUM_FLAT_RATE_BOX_2"] = "MEDIUM_FLAT_RATE_BOX_2";
  PackageType2["LARGE_FLAT_RATE_BOX"] = "LARGE_FLAT_RATE_BOX";
  return PackageType2;
})(PackageType || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var WebhookIdentityType = /* @__PURE__ */ ((WebhookIdentityType2) => {
  WebhookIdentityType2["UNKNOWN"] = "UNKNOWN";
  WebhookIdentityType2["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
  WebhookIdentityType2["MEMBER"] = "MEMBER";
  WebhookIdentityType2["WIX_USER"] = "WIX_USER";
  WebhookIdentityType2["APP"] = "APP";
  return WebhookIdentityType2;
})(WebhookIdentityType || {});
async function createShippoConfiguration2(shippoConfiguration, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest({
      shippoConfiguration,
      backupRate: options?.backupRate
    }),
    [
      {
        transformFn: transformSDKAddressToRESTAddress,
        paths: [{ path: "shippoConfiguration.shipFromAddress" }]
      }
    ]
  );
  const reqOpts = createShippoConfiguration(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTAddressToSDKAddress,
          paths: [{ path: "shippoConfiguration.shipFromAddress" }]
        }
      ])
    )?.shippoConfiguration;
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          shippoConfiguration: "$[0]",
          backupRate: "$[1].backupRate"
        },
        singleArgumentUnchanged: false
      },
      ["shippoConfiguration", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function getShippoConfiguration2(shippoConfigurationId) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    shippoConfigurationId
  });
  const reqOpts = getShippoConfiguration(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTAddressToSDKAddress,
          paths: [{ path: "shippoConfiguration.shipFromAddress" }]
        }
      ])
    )?.shippoConfiguration;
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { shippoConfigurationId: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["shippoConfigurationId"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function updateShippoConfiguration2(_id, shippoConfiguration) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest({
      shippoConfiguration: { ...shippoConfiguration, id: _id }
    }),
    [
      {
        transformFn: transformSDKAddressToRESTAddress,
        paths: [{ path: "shippoConfiguration.shipFromAddress" }]
      }
    ]
  );
  const reqOpts = updateShippoConfiguration(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTAddressToSDKAddress,
          paths: [{ path: "shippoConfiguration.shipFromAddress" }]
        }
      ])
    )?.shippoConfiguration;
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: { shippoConfiguration: "$[1]" },
        explicitPathsToArguments: { "shippoConfiguration.id": "$[0]" },
        singleArgumentUnchanged: false
      },
      ["_id", "shippoConfiguration"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function deleteShippoConfiguration2(shippoConfigurationId) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    shippoConfigurationId
  });
  const reqOpts = deleteShippoConfiguration(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { shippoConfigurationId: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["shippoConfigurationId"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
function queryShippoConfigurations2() {
  const { httpClient, sideEffects } = arguments[0];
  return queryBuilder({
    func: async (payload) => {
      const reqOpts = queryShippoConfigurations(
        payload
      );
      sideEffects?.onSiteCall?.();
      try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return result;
      } catch (err) {
        sideEffects?.onError?.(err);
        throw err;
      }
    },
    requestTransformer: (query) => {
      const args = [query, {}];
      return renameKeysFromSDKRequestToRESTRequest({
        ...args?.[1],
        query: args?.[0]
      });
    },
    responseTransformer: ({
      data
    }) => {
      const transformedData = renameKeysFromRESTResponseToSDKResponse(
        transformPaths2(data, [
          {
            transformFn: transformRESTAddressToSDKAddress,
            paths: [{ path: "shippoConfigurations.shipFromAddress" }]
          }
        ])
      );
      return {
        items: transformedData?.shippoConfigurations,
        pagingMetadata: transformedData?.pagingMetadata
      };
    },
    errorTransformer: (err) => {
      const transformedError = sdkTransformError(err, {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { query: "$[0]" },
        singleArgumentUnchanged: false
      });
      throw transformedError;
    },
    pagingMethod: "CURSOR",
    transformationPaths: {}
  });
}
async function updateExtendedFields2(_id, namespace, options) {
  const { httpClient, sideEffects } = arguments[3];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    id: _id,
    namespace,
    namespaceData: options?.namespaceData
  });
  const reqOpts = updateExtendedFields(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTAddressToSDKAddress,
          paths: [{ path: "shippoConfiguration.shipFromAddress" }]
        }
      ])
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          id: "$[0]",
          namespace: "$[1]",
          namespaceData: "$[2].namespaceData"
        },
        singleArgumentUnchanged: false
      },
      ["_id", "namespace", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function addDeliveryRegion2(shippoConfigurationId, deliveryRegionId, options) {
  const { httpClient, sideEffects } = arguments[3];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    shippoConfigurationId,
    deliveryRegionId,
    revision: options?.revision
  });
  const reqOpts = addDeliveryRegion(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTAddressToSDKAddress,
          paths: [{ path: "shippoConfiguration.shipFromAddress" }]
        }
      ])
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          shippoConfigurationId: "$[0]",
          deliveryRegionId: "$[1]",
          revision: "$[2].revision"
        },
        singleArgumentUnchanged: false
      },
      ["shippoConfigurationId", "deliveryRegionId", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function removeDeliveryRegion2(identifiers, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    shippoConfigurationId: identifiers?.shippoConfigurationId,
    deliveryRegionId: identifiers?.deliveryRegionId,
    revision: options?.revision
  });
  const reqOpts = removeDeliveryRegion(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTAddressToSDKAddress,
          paths: [{ path: "shippoConfiguration.shipFromAddress" }]
        }
      ])
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          shippoConfigurationId: "$[0].shippoConfigurationId",
          deliveryRegionId: "$[0].deliveryRegionId",
          revision: "$[1].revision"
        },
        singleArgumentUnchanged: false
      },
      ["identifiers", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}

// src/ecom-v1-shippo-configuration-shippo-configurations.public.ts
function createShippoConfiguration3(httpClient) {
  return (shippoConfiguration, options) => createShippoConfiguration2(
    shippoConfiguration,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function getShippoConfiguration3(httpClient) {
  return (shippoConfigurationId) => getShippoConfiguration2(
    shippoConfigurationId,
    // @ts-ignore
    { httpClient }
  );
}
function updateShippoConfiguration3(httpClient) {
  return (_id, shippoConfiguration) => updateShippoConfiguration2(
    _id,
    shippoConfiguration,
    // @ts-ignore
    { httpClient }
  );
}
function deleteShippoConfiguration3(httpClient) {
  return (shippoConfigurationId) => deleteShippoConfiguration2(
    shippoConfigurationId,
    // @ts-ignore
    { httpClient }
  );
}
function queryShippoConfigurations3(httpClient) {
  return () => queryShippoConfigurations2(
    // @ts-ignore
    { httpClient }
  );
}
function updateExtendedFields3(httpClient) {
  return (_id, namespace, options) => updateExtendedFields2(
    _id,
    namespace,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function addDeliveryRegion3(httpClient) {
  return (shippoConfigurationId, deliveryRegionId, options) => addDeliveryRegion2(
    shippoConfigurationId,
    deliveryRegionId,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function removeDeliveryRegion3(httpClient) {
  return (identifiers, options) => removeDeliveryRegion2(
    identifiers,
    options,
    // @ts-ignore
    { httpClient }
  );
}
var onShippoConfigurationCreated = EventDefinition(
  "wix.ecom.v1.shippo_configuration_created",
  true,
  (event) => renameKeysFromRESTResponseToSDKResponse2(
    transformPaths3(event, [
      {
        transformFn: transformRESTTimestampToSDKTimestamp2,
        paths: [
          { path: "entity.createdDate" },
          { path: "entity.updatedDate" },
          { path: "metadata.eventTime" }
        ]
      },
      {
        transformFn: transformRESTAddressToSDKAddress2,
        paths: [{ path: "entity.shipFromAddress" }]
      }
    ])
  )
)();
var onShippoConfigurationDeleted = EventDefinition(
  "wix.ecom.v1.shippo_configuration_deleted",
  true,
  (event) => renameKeysFromRESTResponseToSDKResponse2(
    transformPaths3(event, [
      {
        transformFn: transformRESTTimestampToSDKTimestamp2,
        paths: [
          { path: "entity.createdDate" },
          { path: "entity.updatedDate" },
          { path: "metadata.eventTime" }
        ]
      },
      {
        transformFn: transformRESTAddressToSDKAddress2,
        paths: [{ path: "entity.shipFromAddress" }]
      }
    ])
  )
)();
var onShippoConfigurationUpdated = EventDefinition(
  "wix.ecom.v1.shippo_configuration_updated",
  true,
  (event) => renameKeysFromRESTResponseToSDKResponse2(
    transformPaths3(event, [
      {
        transformFn: transformRESTTimestampToSDKTimestamp2,
        paths: [
          { path: "entity.createdDate" },
          { path: "entity.updatedDate" },
          { path: "metadata.eventTime" }
        ]
      },
      {
        transformFn: transformRESTAddressToSDKAddress2,
        paths: [{ path: "entity.shipFromAddress" }]
      }
    ])
  )
)();

// src/ecom-v1-shippo-configuration-shippo-configurations.context.ts
import { createRESTModule } from "@wix/sdk-runtime/rest-modules";
import { createEventModule } from "@wix/sdk-runtime/event-definition-modules";
var createShippoConfiguration4 = /* @__PURE__ */ createRESTModule(createShippoConfiguration3);
var getShippoConfiguration4 = /* @__PURE__ */ createRESTModule(getShippoConfiguration3);
var updateShippoConfiguration4 = /* @__PURE__ */ createRESTModule(updateShippoConfiguration3);
var deleteShippoConfiguration4 = /* @__PURE__ */ createRESTModule(deleteShippoConfiguration3);
var queryShippoConfigurations4 = /* @__PURE__ */ createRESTModule(queryShippoConfigurations3);
var updateExtendedFields4 = /* @__PURE__ */ createRESTModule(updateExtendedFields3);
var addDeliveryRegion4 = /* @__PURE__ */ createRESTModule(addDeliveryRegion3);
var removeDeliveryRegion4 = /* @__PURE__ */ createRESTModule(removeDeliveryRegion3);
var onShippoConfigurationCreated2 = createEventModule(onShippoConfigurationCreated);
var onShippoConfigurationDeleted2 = createEventModule(onShippoConfigurationDeleted);
var onShippoConfigurationUpdated2 = createEventModule(onShippoConfigurationUpdated);
export {
  CalculationType,
  DomesticService,
  InternationalService,
  PackageType,
  SortOrder,
  WebhookIdentityType,
  addDeliveryRegion4 as addDeliveryRegion,
  createShippoConfiguration4 as createShippoConfiguration,
  deleteShippoConfiguration4 as deleteShippoConfiguration,
  getShippoConfiguration4 as getShippoConfiguration,
  onShippoConfigurationCreated2 as onShippoConfigurationCreated,
  onShippoConfigurationDeleted2 as onShippoConfigurationDeleted,
  onShippoConfigurationUpdated2 as onShippoConfigurationUpdated,
  queryShippoConfigurations4 as queryShippoConfigurations,
  removeDeliveryRegion4 as removeDeliveryRegion,
  updateExtendedFields4 as updateExtendedFields,
  updateShippoConfiguration4 as updateShippoConfiguration
};
//# sourceMappingURL=index.mjs.map